/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function salesTypeStart() {
  pushClevertapEvent('Sales Type Start');
}

export function createSalesTypeOneOutletSuccess({
  salesTypeName,
  gratuityAssign,
  numOfGratuity,
  gratuityAssignNameList,
  outletIds,
}) {
  const gratuitiName: any[] = [];
  gratuityAssignNameList.forEach((grat) => {
    gratuitiName.push(grat.name);
  });
  pushClevertapEvent('Create Sales Type one Outlet Success', {
    'Sales Type Name': salesTypeName,
    'Gratuity Assign': gratuityAssign,
    'Num of Gratuity': numOfGratuity,
    'Current Selected Outlet': outletIds,
    'Gratuity Name Assign': gratuitiName,
  });
}

export function createSalesTypeMultipleOutletsSuccess({
  salesTypeName,
  gratuityAssign,
  numOfGratuity,
  gratuityAssignNameList,
  outletIds,
}) {
  const gratuitiName: any[] = [];
  gratuityAssignNameList.forEach((gratId) => {
    gratuitiName.push(gratId.name);
  });
  pushClevertapEvent('Create Sales Type Multiple Outlets Success', {
    'Sales Type Name': salesTypeName,
    'Gratuity Assign': gratuityAssign,
    'Num of Gratuity': numOfGratuity,
    'Gratuity Name Assign': gratuitiName,
    'Current Selected Outlet': outletIds,
  });
}

export function editSalesTypeSuccess({
  oldSalesTypeName,
  oldGratuityAssign,
  newSalesTypeName,
  newGratuityAssign,
  outletIds,
}) {
  pushClevertapEvent('Edit Sales Type Success', {
    'Old Sales Type Name': oldSalesTypeName,
    'Old Gratuity Assign': oldGratuityAssign,
    'New Sales Type Name': newSalesTypeName,
    'New Gratuity Assign': newGratuityAssign,
    'Current Selection Outlet': outletIds,
  });
}

export function salesTypeDeactivate({ salesTypeName, outletIds }) {
  pushClevertapEvent('Sales Type Deactivate', {
    'Sales Type Name': salesTypeName,
    'Current Selection Outlet': outletIds,
  });
}

export function salesTypeReactivate({ salesTypeName, outletIds }) {
  pushClevertapEvent('Sales Type Reactivate', {
    'Sales Type Name': salesTypeName,
    'Current Selection Outlet': outletIds,
  });
}

export function salesTypeDelete({ salesTypeName, outletIds }) {
  pushClevertapEvent('Sales Type Delete', {
    'Sales Type Name': salesTypeName,
    'Current Selection Outlet': outletIds,
  });
}

export function openKnowledgeCenter() {
  pushClevertapEvent('Open Sales Type Knowledge Center');
}
